import { createFileRoute } from '@tanstack/react-router';

import { AdminClubsList } from '@/pages/admin/clubs/AdminClubsList';

export const Route = createFileRoute('/admin/_admin/clubs')({
  component: AdminClubsList
});
